import React, {useState, useEffect } from 'react';
import './companies.css'
import companies from '../../../pages/c2wHomePage/companies/companies.json'
import C2wCompanyCard from '../../../common/C2wHome/companies/companyCard';
import { useNavigate } from 'react-router';

function C2wCompanies() {

    const navigate = useNavigate()

      const [countData, setCountData] = useState(null);
      const [sliceValue, setSliceValue] = useState(23)

      
      /**
 * @hook useEffect - Fetch JSON Data on Mount
 * @author Vishal Lohbande
 *
 * Description:
 * - Fetches JSON data from the `/website.json` endpoint once when the component mounts.
 * - Parses the response and updates the state with the fetched data using `setCountData`.
 *
 * Behavior:
 * - Uses an asynchronous inner function `fetchData` to handle the fetch request.
 * - Throws an error if the response is not successful (`res.ok` is false).
 * - Safely updates state only after successful data retrieval.
 *
 * Usage:
 * - Common pattern for loading static or dynamic data on component initialization.
 * - Suitable for loading configuration, counts, or content from a local JSON file or API.
 *
 * Notes:
 * - Empty dependency array ensures the effect runs only once.
 * - Error handling can be extended as needed for user feedback or retries.
 */
      useEffect(() => {
        const fetchData = async () => {
          const res = await fetch('/website.json'); 
          if (!res.ok) throw new Error('Failed to load JSON');
          const json = await res.json();
          setCountData(json);
        };
        fetchData();
      }, []);


/**
 * @state windowWidth, sliceValue
 * @hook useEffect - Window Resize Listener & sliceValue Setter
 * @author Vishal Lohbande
 *
 * Description:
 * - Tracks the current window width in state `windowWidth`.
 * - Listens for window resize events to update `windowWidth`.
 * - Conditionally sets the `sliceValue` state based on specific window widths.
 *
 * Behavior:
 * - Updates `windowWidth` on every resize.
 * - Uses a series of conditional checks to set `sliceValue` based on exact or range-based window widths:
 *   - > 1540px: sliceValue = 23
 *   - === 1540px or 1440px: sliceValue = 19
 *   - === 1536px, 1366px, or 1358px: sliceValue = 14
 *
 * Usage:
 * - Useful for controlling UI slicing or pagination based on precise screen widths.
 *
 * Notes:
 * - The exact width checks (`===`) are very specific and may miss other widths; consider ranges or more flexible checks.
 * - Cleanup of event listener on component unmount prevents memory leaks.
 */
       const [windowWidth, setWindowWidth] = useState(window.innerWidth);
        useEffect(() => {
          const handleResize = () => {
            setWindowWidth(window.innerWidth);
            if(window.innerWidth > 1600){
                setSliceValue(29)
            }else if(window.innerWidth === 1540 || window.innerWidth === 1600){
                setSliceValue(19)
            }else if(window.innerWidth === 1536){
                setSliceValue(15)
            }else if(window.innerWidth === 1440){
                setSliceValue(19)
            }else if(window.innerWidth === 1366){
                setSliceValue(14)
            }else if(window.innerWidth === 1358){
                setSliceValue(14)
            }else if(window.innerWidth <= 1358 && window.innerWidth >= 1240){
                setSliceValue(15)
            }else if( window.innerWidth >= 768 && windowWidth?.innerWidth <= 1024){
                setSliceValue(10)
                console.log('tab view')
            }
          };

          window.addEventListener('resize', handleResize);
          return () => window.removeEventListener('resize', handleResize);
        }, []);

     /**
 * @constant renderedCompaniesCards
 * @author Vishal Lohbande
 *
 * Description:
 * - Dynamically renders a list of company logo cards by mapping over a sliced portion of `companies.companyLogos`.
 * - The slice length depends on the current `windowWidth`:
 *    - If window width is greater than 620px, slice length is controlled by `sliceValue`.
 *    - Otherwise, it defaults to 11 logos.
 *
 * Behavior:
 * - Uses optional chaining to safely access `companyLogos`.
 * - Maps each logo object to a `C2wCompanyCard` component, passing the logo data as a prop.
 *
 * Usage:
 * - Used to display company logos responsively, showing more or fewer logos depending on screen size.
 *
 * Notes:
 * - Consider adding a unique `key` prop (e.g., logo ID or index) to each `C2wCompanyCard` for React list optimization.
 */   
    const renderedCompaniesCards = companies?.companyLogos?.slice(0, windowWidth > 620  ? sliceValue : 4).map(( obj ) => {
        return <C2wCompanyCard obj={obj}  />
    })

    return (
        <div className='C2wHomeCompanies_ctn'>
            <div className='C2wPlacementsHomeHeading_ctn_hld'>
                <div className='C2wCompanies_heading'>
                    {'Students Placed in '}
                    <span className='C2wPlacementsHeadingSpan'>{'180+ Companies'}</span>
                </div>
            </div>
            <div>
                <div className='C2wCompanies_ctn_companiesCards_htder'>
                    {renderedCompaniesCards}
                    <div style={{background: 'none'}} className='C2wCompanyCard_ctn C2wCompanyCard_ctn_ViewAll' onClick={() => {
                        navigate('/companies')
                    }}>
                        <span className='C2wCompanyCard_ctn_count_span'>+{countData?.companiesCount}</span>
                        <span className='C2wCompanyCard_ctn_count_text'>{'View All Companies'}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default C2wCompanies